import React from 'react';

export default function Analytics() {
  return (
    <>
      <h1 className="wp-portal__page-title">Analytics</h1>
      <p className="wp-portal__page-sub">Catalog performance and reporting.</p>
      <div className="wp-portal__empty">
        <p className="wp-portal__empty-label">
          No analytics data available. Data will appear here once your catalog
          is active and reporting has begun.
        </p>
      </div>
    </>
  );
}
